import styled from "styled-components"
import {Row} from "react-bootstrap"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {greys, perkbox} from "@irati/ui/src/global/colors"
import {H2, H4} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import {LatoLight} from "@irati/ui/src/global/fonts"
import Card from "@irati/ui/src/Layout/Card"
import Link from "@irati/ui/src/Link"
import Banner from "@irati/ui/src/Banner"
import {Caption} from "@irati/ui/src/Labels/Labels"
import padding from "@irati/ui/src/global/padding"
import border from "../../../images/wavyBorder.svg"

const banner = "https://res.cloudinary.com/perkbox/image/upload/v1556812328/deals-light-ui/web/medical/medicalUpsell.jpg"

export const InformationText = styled.div`
  min-height: auto;
  padding-bottom: ${padding.small};
  ${minWidthMedia.desktop`
    margin-top: -30px;
    padding-bottom: ${padding.base};
    & p {
      margin-bottom: 20px;
    }
  `}
`

export const WhiteH2 = styled(H2)`
  color: ${greys.white};
  max-width: 250px;
  ${minWidthMedia.tablet`
    max-width: 100%;
  `}
`

export const WhiteH4 = styled(H4)`
  color: ${greys.white};
`

export const MobileSubHeader = styled.h4`
  font-size: 18px;
  line-height: 22px;
  max-width: 90%;
  margin: 15px auto;
`

export const MobileCallbackWrapper = styled.div`
  max-width: 90%;
  margin: auto;
`

export const Flex = styled.div`
  display: flex;
`

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Small = styled(Caption)`
  color: #BBB;
`

export const StyledLink = styled(Link)`
  color: #BBB;
`

export const BannerHeadings = styled.div`
  max-width: 400px;
  margin-right: ${padding.small};
  ${minWidthMedia.desktop`
    max-width: 500px;
  `}
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StyledRow = styled(Row)`
  margin-bottom: ${padding.large};
`

export const Inline = styled(Para)`
  display: inline;
`

export const MobileBanner = styled(Banner)`
  display: flex;
  align-items: center;
  background: linear-gradient(
    rgba(20,20,20, .3),
    rgba(20,20,20, .3)),
    url(${banner});
  background-position: top center;
  background-size: cover;
`

export const StyledBanner = styled(Banner)`
  background: linear-gradient(rgba(20,20,20, .3), rgba(20,20,20, .3)), url(${banner});
  background-position: 0 34%;
  background-size: cover;
  height: auto;
  max-width: 1170px;
  min-height: 470px;
  margin: 0 auto;
  ${minWidthMedia.largeDesktop`
    &::after{
      content: "";
      position: absolute;
      top: 70%;
      left: 0;
      height: 143px;
      width: 100%;
      background: url(${border}) bottom center;
      background-size: 100%;
    }
  `}
`

export const TestimonialCard = styled(Card)`
  border-radius: 10px;
  box-shadow: 1px 1px 0 2px ${greys.lightest};
  img{
    height: 60px;
    border-top-left-radius: 110px;
    border-top-right-radius: 85px;
    border-bottom-right-radius: 120px;
    border-bottom-left-radius: 75px;
    width: 55px;
  }
`

export const EmojiWrapper = styled.div`
  p {
    color: ${perkbox.greenBlue};
  }
`

export const TestimonialText = styled.p`
    ${LatoLight}
`

export const TestimonialPosition = styled.div`
  margin-left: 25px;
  margin-top: -10px;
`

export const TermsWrapper = styled.div`
  ${minWidthMedia.largeDesktop`
    margin-top: 100px;
  `}
`

export const TermsText = styled.p`
  color: ${greys.mediumDark};
  ${LatoLight};
  font-size: 10px;
  & a {
    color: ${greys.mediumDark};
    ${LatoLight};
    font-size: 10px;
    text-transform: capitalize;
  }
`

export const BorderLine = styled.div`
  height: 200px;
  background: url(${border}) bottom center;
`
